import { Component, input } from '@angular/core';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TableColumn } from '../generic-table/generic-table.component';
import { TableSettingsTestIds } from './table-settings.test-ids';

@Component({
  selector: 'app-table-settings',
  imports: [MatIcon, MatIconButton, MatMenu, MatMenuTrigger, MatCheckbox],
  templateUrl: './table-settings.component.html'
})
/**
 * Begründung: Hierbei handelt es sich um eine generische settings komponente.
 */
export class TableSettingsComponent<T> {
  protected readonly testIds = TableSettingsTestIds;
  allColumns = input.required<TableColumn<T>[]>();
  displayedColumns = input.required<TableColumn<T>[]>();

  isColumnVisible(column: TableColumn<T>): boolean {
    return this.displayedColumns().some(col => col.key === column.key);
  }

  triggerColumnsToShow(event: MatCheckboxChange, column: TableColumn<T>): void {
    const current = this.displayedColumns();

    if (event.checked) {
      if (!current.some(col => col.key === column.key)) {
        const allCols = this.allColumns();
        const columnIndexInAll = allCols.findIndex(col => col.key === column.key);

        let insertPosition = current.length;

        for (let i = 0; i < current.length; i++) {
          const currentColIndex = allCols.findIndex(col => col.key === current[i].key);
          if (currentColIndex > columnIndexInAll) {
            insertPosition = i;
            break;
          }
        }

        current.splice(insertPosition, 0, column);
      }
    } else {
      const index = current.findIndex(col => col.key === column.key);

      if (current.length <= 1) {
        event.source.checked = true;
        return;
      }

      if (index > -1) {
        current.splice(index, 1);
      }
    }
  }
}
